import { useLazyQuery } from '@apollo/react-hooks'
import { Resources } from '@berlitz/icons'
import { StyledButton } from '@components/ViewMaterial/style'
import { IBerlitzEventAttendeeInfo } from '@interfaces/Events'
import { EVENT_TYPES } from '@utils/constants/events'
import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import { EVENT_ATTENDEE_ROLE_HOST } from './constants'
import { GET_ALL_LEARNING_UNITS } from '@queries/learningPath'
import { GetAllLearningUnitsPayload, GetAllLearningUnitsResponse } from '@interfaces/LearningPath'
import { EventOpenMaterialBtnWrapper } from '@layouts/MyLessons/Lessons/style'
import Spacer from '@berlitz/spacer'

export interface IEventOpenMaterialBtn {
  berlitzEventAttendeeInfo: IBerlitzEventAttendeeInfo
  fullWidth?: boolean
  onError?: (error: any) => void
  disable?: boolean
}

const EventOpenMaterialBtn: React.FC<IEventOpenMaterialBtn> = ({
  berlitzEventAttendeeInfo: attendeeInfo,
  fullWidth = true,
  onError = () => {},
  disable = false,
}) => {
  const intl = useIntl()
  const isHost = attendeeInfo.Role?.toLocaleLowerCase() === EVENT_ATTENDEE_ROLE_HOST?.toLowerCase()
  const isGroupConversationClass = attendeeInfo?.EventType === EVENT_TYPES.GROUP_CONVERSATION_CLASS
  const hasTopics = attendeeInfo?.TopicLPID && attendeeInfo?.TopicUnitId

  const [fetching, setFetching] = useState(false)
  const [opened, setOpened] = useState(false)
  const [getAllLearningUnits] = useLazyQuery<GetAllLearningUnitsResponse, GetAllLearningUnitsPayload>(
    GET_ALL_LEARNING_UNITS,
    {
      fetchPolicy: 'network-only',
      onCompleted: (data) => {
        const { getAllLearningUnits } = data || {}
        if (attendeeInfo.TopicUnitId && getAllLearningUnits?.length && !opened) {
          const instructorGuide = getAllLearningUnits
            .find((unit) => unit.unitid === parseInt(attendeeInfo.TopicUnitId!, 10))
            ?.activities?.find((activity) => activity.type === 'ig')
          instructorGuide && window.open(instructorGuide.url, '_blank')?.focus()
        }

        setFetching(false)
        setOpened(true)
      },
      onError: (error) => onError(error),
    }
  )

  if (!isHost) {
    return null
  }

  return (
    <>
      <EventOpenMaterialBtnWrapper>
        <StyledButton
          icon={<Resources color="brand03" size="xs" />}
          iconPosition="left"
          narrow
          fullWidth={fullWidth}
          disabled={disable || fetching || (isHost && (!isGroupConversationClass || !hasTopics))}
          onClick={() => {
            setFetching(true)
            setOpened(false)
            getAllLearningUnits({
              variables: {
                Id: attendeeInfo.TopicLPID!,
                StudentId: '',
              },
            })
          }}
          loading={fetching}
          loadingText={`${intl.formatMessage({ id: 'Opening material...', defaultMessage: 'Opening material...' })}`}
        >
          {intl.formatMessage({ id: 'Open material', defaultMessage: 'Open material' })}
        </StyledButton>
      </EventOpenMaterialBtnWrapper>

      <Spacer size="xs" />
    </>
  )
}

export default EventOpenMaterialBtn
